/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShareModel } from '../../models/share-model';

export interface UserShareV20SharesOrganizationCoordinationGet$Params {
  organizationId: string;
  coordinationId: string;
  'api-version'?: string;
}

export function userShareV20SharesOrganizationCoordinationGet(http: HttpClient, rootUrl: string, params: UserShareV20SharesOrganizationCoordinationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ShareModel>>> {
  const rb = new RequestBuilder(rootUrl, userShareV20SharesOrganizationCoordinationGet.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('coordinationId', params.coordinationId, {});
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ShareModel>>;
    })
  );
}

userShareV20SharesOrganizationCoordinationGet.PATH = '/api/user-share/v2-0/shares/organization/{organizationId}/coordination/{coordinationId}';
